<template>
    <v-menu v-model="timeMenu"
            ref="timeMenu"
            :close-on-content-click="false"
            :left="!landscape"
            transition="scale-transition"
    >
        <template v-slot:activator="{ on }">
            <v-text-field v-on="on"
                          prepend-icon="access_time"
                          :value="formatTime(timeClone)"
                          readonly
            />
        </template>
        <v-time-picker v-if="!disabled && timeMenu"
                       v-model="timeClone"
                       :format="timePickerFormat"
                       :landscape="landscape"
                       :max="maxTime"
                       :min="minTime"
                       ampm-in-title
                       @click:minute="$refs.timeMenu.save(timeClone)"
        />
    </v-menu>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import DateTimeUtil from '@/util/date-time-util';

export default {
  name: 'TimePairTimePicker',
  props: {
    disabled: Boolean,
    timeEntry: {
      type: Object,
      required: true,
    },
    max: String,
    min: String,
  },

  data() {
    return {
      timeMenu: false,
      timeClone: {},
    };
  },

  watch: {
    timeEntry() {
      this.resetTime();
    },

    timeClone(value) {
      this.$emit('update', { entryType: this.timeEntry.entryType, newTime: value });
    },
  },

  computed: {
    maxTime() {
      if (!isEmpty(this.max)) {
        if (DateTimeUtil.convertDateTimeToDate(this.timeEntry.date)
            !== DateTimeUtil.convertDateTimeToDate(this.max)) {
          return DateTimeUtil.constants.midnightTimeEndOfDay;
        }
        return DateTimeUtil.convertDateTimeToTime(this.max);
      }
      return null;
    },

    minTime() {
      if (!isEmpty(this.min)) {
        if (DateTimeUtil.convertDateTimeToDate(this.timeEntry.date)
            !== DateTimeUtil.convertDateTimeToDate(this.min)) {
          return DateTimeUtil.constants.midnightTimeStartOfDay;
        }
        return DateTimeUtil.convertDateTimeToTime(this.min);
      }
      return null;
    },

    timePickerFormat() {
      return DateTimeUtil.is24HourTimeUsed() ? '24hr' : 'ampm';
    },

    landscape() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return false;
        default: return true;
      }
    },
  },

  methods: {
    formatTime(time) {
      return DateTimeUtil.convertToHumanReadableTime(time);
    },

    resetTime() {
      this.timeClone = DateTimeUtil.convertDateTimeToTime(this.timeEntry.date);
    },
  },

  created() {
    this.resetTime();
  },
};
</script>
